import { Injectable } from '@angular/core';
import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class BaseUrlInterceptor implements HttpInterceptor {
  constructor(
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (/^https?:\/\//i.test(req.url)) {
      return next.handle(req);
    }

    const requestWithBaseUrl = req.clone({
      url: this.getRequestUrl(req),
    });

    return next.handle(requestWithBaseUrl);
  }

  getRequestUrl(req: HttpRequest<any>) {
    const baseUrl = /\/$/.test(environment.apiUrl) ?
      environment.apiUrl.substring(0, environment.apiUrl.length - 1) :
      environment.apiUrl;

    const requestUrl = /^\//.test(req.url) ? req.url.substring(1, req.url.length) : req.url;
    return baseUrl ? `${baseUrl}/${requestUrl}` : req.url;
  }
}
